// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"388":"cd7094d6","457":"fe132bb1","828":"20f47134","851":"3b6c55c5"}[chunkId] + ".chunk.js";
};